var portfolioEdit = {
	confirmBtn: "Ok",
	cancelBtn: "Annuleren",
	title: "Bewerk virtuele portfolio",
	nameInputLabel: "Portfolio-naam",
	nameInputPlaceholder: "Voer alstublieft een naam in",
	nameInputTip: "Max. 100 characters – Geldige tekens: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	currencyInputLabel: "Portfolio Basisvaluta",
	currencyInputPlaceholder: "Selecteer een valuta",
	limitExceededMessage: "Portfolio-limiet overschreden.",
	currencies: {
		euro: "Euro",
		usd: "Amerikaanse Dollar",
		chf: "Zwitserse Frank",
		gbp: "Britse Pond",
		jpy: "Japanse Yen",
		cad: "Canadese Dollar"
	},
	validationErrors: {
		name: {
			invalidInput: "Naam is ongeldig. Max 100 karakters – Geldige tekens: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var nl = {
	portfolioEdit: portfolioEdit
};

export { nl as default, portfolioEdit };
